import OurFinds from "../components/OurFinds";


const OurFindsView = () => {

    return (
        <div className="our-finds">
            <OurFinds/>
        </div>
    );
};

export default OurFindsView;